import {
  common,
  mask,
  slidersAndNumbers,
  geography,
  spinners,
  checkboxRadio,
  inputGroup,
  otpRating,
  combo,
  comboMultiple,
  tagbox,
  address,
  editors,
  audioVideo,
  lists,
  comboAccordion,
  uploads,
  multiList,
  treeList,
  hidden,
  love,
  dialog
} from './forms.js';
import { slidersSkin2 } from './sliders-skin2.js';
import { visualPickers } from './pickers.js';
import { geodoc } from './geodoc.js';

/**
 * LAYOUT DA ABA FORMULÁRIOS
 *
 * Este arquivo não ensina a configurar campos. As configurações principais
 * estão em forms.js; os pickers visuais ficam isolados em pickers.js e o
 * exemplo do GeoDoc em geodoc.js para que os componentes compostos sejam fáceis
 * de localizar e copiar. Aqui a única responsabilidade é organizar os exemplos
 * na tela.
 *
 * Os fieldsets que já existiam no tutorial foram preservados. Os componentes
 * que antes estavam soltos no bloco geral ganharam fieldsets próprios para
 * facilitar a localização sem mudar sua configuração funcional.
 */

/**
 * O tutorial antigo ainda tinha `element: 'color'` dentro de Common. Esse campo
 * é o input de cor legado do navegador e não representa o ColorPicker
 * compartilhado. Mantemos a configuração de referência em forms.js, mas ela
 * deixa de ser renderizada no tutorial para não concorrer visualmente com o
 * novo componente.
 */
const commonFields = {
  ...common,
  content: Array.isArray(common.content)
    ? common.content.filter((field) => field?.element !== 'color')
    : common.content
};

/**
 * Primeiro fieldset do tutorial.
 *
 * ColorPicker e IconPicker ficam no topo, fora de tabs, para que apareçam
 * imediatamente ao abrir Formulários. Os demais grupos preservam a organização
 * anterior.
 */
const basicFields = {
  element: 'group',
  type: 'fieldset',
  style: { width: '1600px' },
  cols: 2,
  groups: [
    visualPickers,
    love,
    commonFields,
    mask,
    slidersAndNumbers,
    slidersSkin2,
    spinners,
    geography,
    geodoc
  ]
};

/**
 * O tutorial antigo mostrava dois painéis lado a lado:
 * - uma tab à esquerda;
 * - um accordion à direita.
 *
 * Mantemos a mesma ideia visual, mas agora tudo pertence explicitamente à aba
 * Formulários em vez de ser criado diretamente no `main`.
 */
const fieldCatalog = {
  element: 'div',
  isGrid: true,
  cols: 2,
  style: {
    width: '1600px',
    gap: '1rem'
  },
  content: [
    {
      element: 'group',
      type: 'tab',
      style: { width: '610px' },
      row: 0,
      col: 0,
      groups: [
        checkboxRadio,
        inputGroup,
        otpRating,
        combo,
        comboMultiple,
        tagbox,
        address
      ]
    },
    {
      element: 'group',
      type: 'accordion',
      style: { width: '640px' },
      row: 0,
      col: 1,
      groups: [
        editors,
        audioVideo,
        lists,
        comboAccordion,
        {
          legend: { icon: { type: 'solid', name: 'heart' }, text: 'Amor' },
          isGrid: true,
          content: 'Eu amo muito a peixudinha'
        }
      ]
    }
  ]
};

/**
 * Campos que estavam misturados no bloco visual do tutorial antigo.
 *
 * Upload, MultiList, TreeList e Hidden são campos de formulário. Eles não vão
 * para Elementos, Board ou Calendário.
 */
const advancedFields = {
  element: 'group',
  type: 'fieldset',
  style: { width: '1600px' },
  groups: [
    uploads,
    multiList,
    treeList,
    hidden
  ]
};

/**
 * Conteúdo que será colocado dentro da aba Formulários.
 *
 * O array explícito deixa a ordem da página óbvia para quem abrir este arquivo.
 */
const formsLayout = [
  {
    element: 'form',
    tag: 'form',
    id: 'tutorial-form-components',
    autocomplete: 'off',
    content: [
      basicFields,
      { element: 'hr' },
      fieldCatalog,
      { element: 'hr' },
      advancedFields
    ]
  }
];

export { dialog };
export default formsLayout;
